<template>
    <b-container fluid>      

      <b-tabs >
        <b-tab title="Transacciones" active>
          <b-row align-h="center"> 
            <b-col>
              <b-row cols="12">
                <b-col lg="6" sm="12" >
                  <b-form-select v-model="cliente" :options="clientes" @change="desplegarMenu(cliente)"></b-form-select>
                </b-col >
                <b-col cols = "12">
                  <b-row v-if="banderaCliente=='En curso'">
                    <b-col lg="6" sm="12">
                      <b-form-input size="sm" placeholder="Password" v-model="pass"></b-form-input>
                    </b-col>

                    <b-col lg="6" sm="12" >
                    <b-form-file v-model="file" plain></b-form-file>
                    <b-button @click="cargarArchivo()" variant="danger">Cargar archivo</b-button>
                    </b-col>

                    <b-col sm="12">
                      <b-form-input v-model="folio_like" placeholder="Folio"></b-form-input>
                    </b-col>
                    <b-col sm="12">
                      <b-form-input v-model="usuario" placeholder="Usuario"></b-form-input>
                      <b-icon icon="person" @click = "listaUsuarios"/>
                    </b-col>
                    <b-col sm="12">
                      <label>Ingrese la fecha de inicio:</label>
                      <b-form-datepicker v-model="fecha_inicio"></b-form-datepicker>
                    </b-col>
                    <b-col sm="12">
                      <label>Ingrese la fecha final:</label>
                      <b-form-datepicker v-model="fecha_final"></b-form-datepicker>
                    </b-col>
                    <b-col sm="12">
                      <b-form-select v-model="cve_ingreso" :options="claves_ingreso"></b-form-select>
                    </b-col>
                    <b-col sm="12">
                      <b-form-select v-model="cve_contable" :options="cuentas_contables"></b-form-select>
                    </b-col>
                    <b-col sm="12">
                      <b-form-input v-model="id_contribuyente" placeholder="ID del contribuyente"></b-form-input>
                    </b-col>
                    <b-col sm="12">
                      <b-form-select v-model="tipo_transaccion" :options="catalogo_tipo_transaccion"></b-form-select>
                    </b-col>
                    <b-col sm="12">
                      <b-form-select v-model="tipo_sistema" :options="catalogo_tipo_sistema"></b-form-select>
                    </b-col>
                    <b-col sm="12">
                      <b-button @click="onReset" variant="danger">Limpiar opciones de busqueda</b-button>
                      <b-button @click="consultarTabla" variant="success">Consultar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>




              <b-row>
                <b-col lg="6" sm="12" >
                  <div v-if="banderaConsultar=='En curso'">
                    <b-table striped hover :items="registros" :fields="columnas" responsive="lg" >
                      

                      <template v-slot:cell(activo)="row">
                        <b-form-checkbox  v-model="row.item.activo"  value="activado" unchecked-value="no activado"></b-form-checkbox>
                      </template>

                      <template v-slot:cell(_00_id_transaccion)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_00_id_transaccion')" >{{ row.item._00_id_transaccion }}</span>
                      </template>

                      <template v-slot:cell(_01_id_contribuyente)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_01_id_contribuyente')" >{{ row.item._01_id_contribuyente }}</span>
                      </template>

                      <template v-slot:cell(_02_sistema)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_02_sistema')" >{{ row.item._02_sistema }}</span>
                      </template>

                      <template v-slot:cell(_03_cve_ingreso)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_03_cve_ingreso')" >{{ row.item._03_cve_ingreso }}</span>
                      </template>

                      <template v-slot:cell(_04_nombre)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_04_nombre')" >{{ row.item._04_nombre }}</span>
                      </template>

                      <template v-slot:cell(_05_rfc)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_05_rfc')" >{{ row.item._05_rfc }}</span>
                      </template>

                      <template v-slot:cell(_06_direccion)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_06_direccion')" >{{ row.item._06_direccion }}</span>
                      </template>

                      <template v-slot:cell(_07_fec_pago)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_07_fec_pago')" >{{ row.item._07_fec_pago.fechaDDMMAAAAHHMMSS }}</span>
                      </template>

                      <template v-slot:cell(_08_fol_rec)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_08_fol_rec')" >{{ row.item._08_fol_rec }}</span>
                      </template>

                      <template v-slot:cell(_09_importe)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_09_importe')" >{{ row.item._09_importe }}</span>
                      </template>

                      <template v-slot:cell(_10_actualizacion)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_10_actualizacion')" >{{ row.item._10_actualizacion }}</span>
                      </template>

                      <template v-slot:cell(_11_recargo)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_11_recargo')" >{{ row.item._11_recargo }}</span>
                      </template>

                      <template v-slot:cell(_12_multa)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_12_multa')" >{{ row.item._12_multa }}</span>
                      </template>

                      <template v-slot:cell(_13_gtos_ejec)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_13_gtos_ejec')" >{{ row.item._13_gtos_ejec }}</span>
                      </template>

                      <template v-slot:cell(_13_2_iva)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_13_2_iva')" >{{ row.item._13_2_iva }}</span>
                      </template>

                      <template v-slot:cell(_14_sub_impto)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_14_sub_impto')" >{{ row.item._14_sub_impto }}</span>
                      </template>

                      <template v-slot:cell(_15_sub_rec)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_15_sub_rec')" >{{ row.item._15_sub_rec }}</span>
                      </template>

                      <template v-slot:cell(_16_sub_multa)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_16_sub_multa')" >{{ row.item._16_sub_multa }}</span>
                      </template>

                      <template v-slot:cell(_17_sub_gtos)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_17_sub_gtos')" >{{ row.item._17_sub_gtos }}</span>
                      </template>

                      <template v-slot:cell(_18_mes_inicial)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_18_mes_inicial')" >{{ row.item._18_mes_inicial }}</span>
                      </template>

                      <template v-slot:cell(_19_mes_final)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_19_mes_final')" >{{ row.item._19_mes_final }}</span>
                      </template>

                      <template v-slot:cell(_20_año)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_20_año')" >{{ row.item._20_año }}</span>
                      </template>

                      <template v-slot:cell(_21_ord_pago)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_21_ord_pago')" >{{ row.item._21_ord_pago }}</span>
                      </template>

                      <template v-slot:cell(_22_vigente)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_22_vigente')" >{{ row.item._22_vigente }}</span>
                      </template>

                      <template v-slot:cell(_23_tipo_cobertura)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_23_tipo_cobertura')" >{{ row.item._23_tipo_cobertura }}</span>
                      </template>

                      <template v-slot:cell(_24_fec_alta)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_24_fec_alta')" >{{ row.item._24_fec_alta.fechaDDMMAAAAHHMMSS }}</span>
                      </template>

                      <template v-slot:cell(_25_cuentaContable)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_25_cuentaContable')" >{{ row.item._25_cuentaContable }}</span>
                      </template>

                      <template v-slot:cell(_26_usuario)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_26_usuario')" >{{ row.item._26_usuario }}</span>
                      </template>

                      <template v-slot:cell(_27_extras)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_27_extras')" >{{ row.item._27_extras.bases }}</span>
                      </template>

                      <template v-slot:cell(_28_forma_pago)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_28_forma_pago')" >{{ row.item._28_forma_pago }}</span>
                      </template>

                      <template v-slot:cell(_29_id_corte)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_29_id_corte')" >{{ row.item._29_id_corte }}</span>
                      </template>

                      <template v-slot:cell(_30_oficina)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_30_oficina')" >{{ row.item._30_oficina }}</span>
                      </template>

                      <template v-slot:cell(_31_base_gravable)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_31_base_gravable')" >{{ row.item._31_base_gravable }}</span>
                      </template>
                      
                      <template v-slot:cell(_32_num_tarjeta)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_32_num_tarjeta')" >{{ row.item._32_num_tarjeta }}</span>
                      </template>
                      
                      <template v-slot:cell(_33_banco_emisor)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_33_banco_emisor')" >{{ row.item._33_banco_emisor }}</span>
                      </template>
                      
                      <template v-slot:cell(_34_banco_receptor)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_34_banco_receptor')" >{{ row.item._34_banco_receptor }}</span>
                      </template>
                      
                      <template v-slot:cell(_35_autorizacion)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_35_autorizacion')" >{{ row.item._35_autorizacion }}</span>
                      </template>
                      
                      <template v-slot:cell(_36_total_neto)="row">
                        <span @click="openEditModal(row.item.id_transaccion, '_36_total_neto')" >{{ row.item._36_total_neto }}</span>
                      </template>

                    </b-table>
                    <b-row>
                      <b-col lg="6" sm="12" >
                        <b-button size="sm" @click="enviarDatos">
                          Guardar
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>

              <b-row v-if="banderaCliente=='En curso'">
                      <b-col lg="6" sm="12" >
                        <b-form-textarea
                          v-model="query"
                          placeholder="Ingrese su query"
                          rows="3"
                          max-rows="6"
                        ></b-form-textarea>
                      </b-col>
              </b-row>
                      
              <b-row>
                <b-modal hide-footer header-bg-variant="dark" header-text-variant="light" title="Editar"  v-model="modalShow">


                  <b-col v-if="nombre_columna_consultada.includes('ingreso')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-form-select v-model="valor_columna_consultada" :options="claves_ingreso"></b-form-select>
                  </b-col>

                  <b-col v-if="nombre_columna_consultada.includes('fec_pago')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-form-datepicker v-model="valor_columna_consultada"></b-form-datepicker>
                  </b-col>

                  <b-col v-if="nombre_columna_consultada.includes('vigente')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-form-checkbox  v-model="valor_columna_consultada"  ></b-form-checkbox>
                  </b-col>

                  <b-col v-if="nombre_columna_consultada.includes('fec_alta')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-form-datepicker v-model="valor_columna_consultada"></b-form-datepicker>
                  </b-col>

                  <b-col v-if="nombre_columna_consultada.includes('usuario')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-form-select v-model="valor_columna_consultada" :options="usuarios"></b-form-select>
                  </b-col>

                  <b-col v-if="nombre_columna_consultada.includes('extras')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-row >
                    <b-col sm="12" class="mt-3" v-for="extra in extras_actual" :key="extra.no">
                      <h6>{{ extra.nombre }} 
                        <b-icon icon="trash" font-scale=".8" style="color:red " @click = "eliminarExtra(extra.nombre)"/>
                      </h6>
                      <b-form-input v-model="extra.valor"></b-form-input>
                    </b-col>
                    </b-row>
                    
                    <b-row >
                      <b-col class="mt-2" >
                        <b-form-select v-model="nuevo_nombre_extra" :options="catalogo_extras"></b-form-select>
                        <b-form-input size="sm" placeholder="Nombre" v-model="nuevo_nombre_extra"></b-form-input>
                        <b-form-input size="sm" placeholder="Valor" v-model="nuevo_valor_extra"></b-form-input>
                      </b-col>
                      <b-col class="mt-3">
                        <b-button @click="agregaNuevaExtra()">Agregar</b-button>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col v-if="!nombre_columna_consultada.includes('extras')&&!nombre_columna_consultada.includes('vigente')">
                    <h5> {{ nombre_columna_consultada }}</h5>
                    <b-form-input size="sm" placeholder="Ingrese el nuevo valor" v-model="valor_columna_consultada" ></b-form-input>
                  </b-col>
                  <p></p>
                  {{ extras_actual }}
                  <b-button variant="success" block @click="botonAplicar">Aplicar</b-button>
                </b-modal>
              </b-row>

              <b-row>
                <b-modal hide-footer header-bg-variant="dark" header-text-variant="light" title="Editar"  v-model="modalShowUsuario">
                    <b-row >
                    <b-col sm="12" class="mt-3" v-for="usuario in usuarios" :key="usuario.value">
                      <h6>{{ usuario.value }}</h6>
                    </b-col>
                    </b-row>   
                </b-modal>
              </b-row>
            </b-col>
          </b-row> 
        </b-tab>
        <b-tab title="Otro">
          <b-row>
            <b-form-select v-model="service" :options="['genkaviraservices','genfactpropadron','genfactpropadronpagos','genpagoscontribsifi','genpagoscontribsifia']">

            </b-form-select>
          </b-row>
          <b-row>
            <b-form-textarea
              v-model="texto"
              rows="10"
              max-rows="10"
            ></b-form-textarea>
          </b-row>
          <b-row>
            <b-col>
              <b-button @click="enviarLayout">Send</b-button>
              <b-button @click="texto=''">Clear</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-form-textarea
              v-model="respuesta"
              rows="10"
              max-rows="10"
            ></b-form-textarea>
          </b-row>
        </b-tab>
        <b-tab title="ixta">
          <b-row>
            <b-column>
              <b-button @click="getPadronIxta">Padron</b-button>
            </b-column>
          </b-row>
        </b-tab>
        <b-tab title="Root">
          
          <b-row>
            <b-form-textarea
              v-model="textoDecrypt"
              rows="10"
              max-rows="10"
            ></b-form-textarea>
          </b-row>
          <b-row>
            <b-col>
              <b-button @click="encrypt">Encrypt</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-form-textarea
              v-model="textoEncrypt"
              rows="10"
              max-rows="10"
            ></b-form-textarea>
          </b-row>
          <b-row>
            <b-col>
              <b-button @click="decrypt">Decrypt</b-button>
            </b-col>
          </b-row>
          
          
        </b-tab>
        <b-tab title="ixta">
          <b-row>
            <b-column>
              <b-button @click="getPadronIxta">Padron</b-button>
            </b-column>
          </b-row>
        </b-tab>
      </b-tabs>

      
    </b-container>
</template>

<script>
import axios from 'axios'
import { server, getPostConfig, getGetConfig} from '@/axios-tools'

export default {
  data(){
    return{
      
      texto:"",
      respuesta:"",

        nuevo_nombre_extra: null,
        nuevo_valor_extra: '',

        extras_actual: [],



        modalShow: false,
        modalShowUsuario: false,

        banderaBusqueda:'',
        banderaConsultar:'',
        banderaCliente:'',

        folio:'',
        pass:'',

        query:'',

        cliente:null,

        id_contribuyente: '',       
        tipo_transaccion: null,
        tipo_sistema: null,
        fecha_inicio:'',
        fecha_final:'',
        usuario:'',
        cve_ingreso:null,
        cve_contable:null,
        folio_like:'',
        file:null,


        id_transaccion_consultada: '',
        nombre_columna_consultada: '',
        valor_columna_consultada: '',

       
        registros: [
        ],
        columnas: [
          "activo",
          "_00_id_transaccion",
          "_01_id_contribuyente",
          "_02_sistema",
          "_03_cve_ingreso",
          "_04_nombre",
          "_05_rfc",
          "_06_direccion",
          "_07_fec_pago",
          "_08_fol_rec",
          "_09_importe",
          "_10_actualizacion",
          "_11_recargo",
          "_12_multa",
          "_13_gtos_ejec",
          "_13_2_iva",
          "_14_sub_impto",
          "_15_sub_rec",
          "_16_sub_multa",
          "_17_sub_gtos",
          "_36_total_neto",
          "_18_mes_inicial",
          "_19_mes_final",
          "_20_año",
          "_21_ord_pago",
          "_22_vigente",
          "_23_tipo_cobertura",
          "_24_fec_alta",
          "_25_cuentaContable",
          "_26_usuario",
          "_27_extras",          
          "_28_forma_pago",
          "_31_base_gravable",
          "_32_num_tarjeta",
          "_33_banco_emisor",
          "_34_banco_receptor",
          "_35_autorizacion",          
          "_29_id_corte",
          "_30_oficina",
        ],

        claves_ingreso: [
        ],

        cuentas_contables: [
        ],

        usuarios: [
        ],


        catalogo_extras: [
        ],


        clientes: [
          'acaltenco',
          'acolman',
          'aguaacolman',
          'aguaaculco',
          'aguacalimaya',
          'aguachicoloapan',
          'aguahuixquilucan',
          'aguatenangodelvalle',
          'aguateotihuacan',
          'amecameca',
          'pruebas',
          'calimaya',
          'coyotepec',
          'difcalimaya',
          'diftenangodelvalle',
          'diftepetlaoxtoc',
          'edudemo',
          'hueyotlipan',
          'hueytamalco',
          'imcutenangodelvalle',
          'imteotihuacan',
          'jilotepec',
          'pahuatlan',
          'palmar',
          'puruandiro',
          'reglamentostula',
          'taxco',
          'tenangodelvalle',
          'teoloyucan',
          'teotihuacan',
          'tepetlaoxtoc',
          'tlachichuca',
          'tlalnepantlamor',
          'tula',
          'tultepec',
          'zautla',
        ],

        catalogo_tipo_transaccion: [
          { value: null, text: 'Seleccione el tipo de transaccion' },
          { value: 1, text: 'PAGADO'},
          { value: 2, text: 'CUBIERTO'},
          { value: 3, text: 'ADEUDO'},
          { value: 4, text: 'CREDITO'}
        ],

        catalogo_tipo_sistema: [
          { value: null, text: 'Seleccione el tipo de sistema' },
          { value: "S", text: 'GOBINET'},
          { value: "C", text: 'EXTERNO'},

        ]
        ,

        textoDecrypt:"",
        textoEncrypt:"",
          

    }
  },
  components: {
  },
  methods:{

    encrypt(){
      axios({
        method: 'post',
        url: 'http://192.168.0.101:8080/enroot',
        params:{},
        data: {data : this.textoDecrypt},
        
      })
      .then(res => {
        this.textoEncrypt = res.data;
      }).catch(err => {
          alert(err);
      });
    },
    decrypt(){
      axios({
        method: 'post',
        url: 'http://192.168.0.101:8080/deroot',
        params:{},
        data: {data : this.textoEncrypt},
        
      })
      .then(res => {
        this.textoDecrypt = res.data;
      }).catch(err => {
          alert(err);
      });
    },
    getPadronIxta(){
      let data = new FormData();
      data.append('route', 'buscapadron');
      data.append('id', '');
      data.append('numero_contrato', '');
      data.append('id_colonia', '3');
      axios({
        method: 'post',
        url: 'https://sistema.opdapas-ixtapan.gob.mx/index.php',
        params:{"codeClient":this.cliente},
        data: data,
        headers: {
           'Cookie': 'PHPSESSID=4aea4f1dd0e6c038bc52703197ea8389',
           'Cache-Control':'no-cache',
           'origin':'https://sistema.opdapas-ixtapan.gob.mx'
           
        },
      })
      .then(res => {
        alert(res.data)
      }).catch(err => {

          alert(err);
      });
    },
    enviarDatos(){
        
      axios({
        method: 'post',
        url: this.url+'updatetrans',
        params:{"codeClient":this.cliente},
        data: this.registros
      })
      .then(() => {
        alert('Registro actualizado')
        this.registros = []
      }).catch(err => {

          alert(err);
      });
    },
    listaUsuarios(){

      this.modalShowUsuario = true   
    },
    eliminarExtra(extraNombreEliminar){

      for (let i = 0; i <this.extras_actual.length; i++) {

        if (this.extras_actual[i].nombre == extraNombreEliminar){
          this.extras_actual.splice(i, 1);
          break;
        }
      }
    },
    agregaNuevaExtra(){
      let nuevaExtra ={
        nombre: this.nuevo_nombre_extra,
        valor: this.nuevo_valor_extra
      }
      this.extras_actual.push(nuevaExtra);
      
      this.nuevo_nombre_extra='';
      this.nuevo_valor_extra='';
    },
    desplegarMenu(clienteSeleccion){
            
      for (let i = 0; i <this.clientes.length; i++) {
        if (this.clientes[i].value == clienteSeleccion){
          alert('Depliega catalogos del cliente seleccionado')
        }
      }

      axios(
        getGetConfig(server.catsroot, null, null, {codeClient:clienteSeleccion})
      )
      .then(res => {
          //2xx
          this.claves_ingreso = res.data.clavesIngreso;
          this.cuentas_contables = res.data.cuentasContables;
          this.usuarios = res.data.usuarios;
          this.catalogo_extras = res.data.nombresExtras;


      }).catch(err => {
          //errores
          alert(err);
      });
      this.banderaCliente = 'En curso';
    },      
    openEditModal(id_transaccion, nombreColumna){

      this.id_transaccion_consultada=id_transaccion;
      this.nombre_columna_consultada=nombreColumna      

      let siHayActivos = false;
      for (let i = 0; i <this.registros.length; i++) {
        if (this.registros[i].activo=='activado'){
          siHayActivos = true;
        }
      }
      let abrirModal = false
      if(siHayActivos){
        for (let i = 0; i <this.registros.length; i++) {

          
          if (this.registros[i].activo=='activado' && this.registros[i].id_transaccion==id_transaccion){
              this.valor_columna_consultada=this.registros[i][nombreColumna]; //[nombreColumna]<< Se utiliza para referenciar una columna que ya existe
              abrirModal = true              
          }
        }

      }else{
        alert('SELECCIONE AL MENOS UN REGISTRO PARA CONTINUAR')

      }
      
      if(this.nombre_columna_consultada.includes('extras')){
        this.extras_actual = [];
        let tokens=this.valor_columna_consultada.bases.split('¡');



        for(let i=0; i<tokens.length; i++){
          let extra = {
            nombre:tokens[i].split(':')[0],
            valor:tokens[i].split(':')[1],
            no:i
          }
          this.extras_actual.push(extra);
        }
      }

      if(abrirModal){
        this.modalShow = true   
      }

    },
    botonAplicar(){

      if(this.nombre_columna_consultada.includes('extras')){

        let extras_modificado = '';
        for (let i = 0; i <this.extras_actual.length; i++) {

          if (i == this.extras_actual.length - 1){        
            extras_modificado = extras_modificado + this.extras_actual[i].nombre+':'+this.extras_actual[i].valor+'¬¬'
          }

          else{
            extras_modificado = extras_modificado + this.extras_actual[i].nombre+':'+this.extras_actual[i].valor+'¡'

          }
          this.valor_columna_consultada.bases=extras_modificado;
        }
      }

      for (let i = 0; i <this.registros.length; i++) {
        if(this.registros[i].activo=="activado"){
          this.registros[i][this.nombre_columna_consultada]=this.valor_columna_consultada;
        }
      }

      this.modalShow = false;
      
    },
    onReset() {

      // Valores al resetear campos de busqueda
      this.fecha_inicio = null
      this.fecha_final = null
      this.usuario = null
      this.cve_ingreso = null
      this.cve_contable = null
      this.folio_like = null
      this.file = null
    },
    cargarArchivo() {
      // Valores al resetear campos de busqueda    
      alert('Se e ha cargado el archivo');
    },
    consultarTabla(){
      this.banderaConsultar = 'En curso';
      let data={
              "idContribuyente": this.id_contribuyente,
              "tipoTransaccion":this.tipo_transaccion,
              "tipoSistema":this.tipo_sistema,
              "fecInicio":this.fecha_inicio,
              "fecFinal":this.fecha_final,
              "usuario":this.usuario,
              "claveIngreso":this.cve_ingreso,
              "cuentaContable":this.cve_contable,
              "folioRegex":this.folio_like,
              "archivoLista":this.file
        }
      axios(
        getPostConfig(server.consultatransroot, data, null, {"codeClient":this.cliente})        
      )
      .then(res => {
        this.registros = res.data
        for(let i = 0; i <this.registros.length; i++){
          this.registros[i].activo="no activado"
        }

      }).catch(err => {
          //errores
          alert(err);
      });
        
    },
    reiniciarConsultarTabla(){
      this.banderaConsultar = '';
    },
    enviarLayout(){
      this.respuesta="";
      var body= JSON.parse(this.texto);
      axios(
          getPostConfig(server.updatetransroot, body, null, {})
          
      )
      .then(res => {
         this.respuesta=res.data;
      }).catch(err => {
         alert('error '+err)
      });
        
    },
   
  
  }
}
</script>
<style>
  
</style>